export default __webpack_public_path__ + "static/press-awards-minnesota-bf6ca9a55d66f8ec1453fa4c4c768d3c.png";